module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/time-e1c867193368c08afaeb3661a8711f99.svg";